<template>
    <div class="c_table_wrap">
        <table class="memberInfo_table">
            <colgroup>
                <col width="150px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">
                    노출순서*
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input v-model="stepSeq" maxLength="20" @input="parentChange('stepSeq', stepSeq)" :readonly="isFinishSave()"></el-input>
                        <div class="input_error">{{ validation.firstError('stepSeq') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">
                    말하기 문구 (한국어)*
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input v-model="talkKorean" maxLength="20" @input="parentChange('talkKorean', talkKorean)" :readonly="isFinishSave()"></el-input>
                        <div class="input_error">{{ validation.firstError('talkKorean') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">
                    말하기 문구 (영어)*
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input v-model="talkEnglish" maxLength="100" @input="parentChange('talkEnglish', talkEnglish)" :readonly="isFinishSave()"></el-input>
                        <div class="input_error">{{ validation.firstError('talkEnglish') }}</div>
                    </div>
                </td>
            </tr>
            <tr v-if="isFinishSave()">
                <td class="c_t_title">
                    음성 파일
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-link v-if="hasAudioFile()" @click="apiFileDownload(ssamTalkData.File[0].org_url, ssamTalkData.File[0].org_name)">{{ssamTalkData.File[0].org_name}}</el-link>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import ssamTalkValidator from "@/components/ssamtalk/ssamTalkValidator";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import {apiFileDownload} from "@/mixins/fileApiDown";
export default {
    name: "SsamTalkWriteStepLayout",
    mixins: [ssamTalkValidator],
    components: {},
    inject: ["ssamTalkWriteSetData"],
    provide() {
        return {}
    },
    props: {
        ssamTalkData: {
            default: () => {
            }
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        this.initData();
        EventBus.$on("SsamTalkWriteStepLayoutValidator", this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off("SsamTalkWriteStepLayoutValidator");
    },
    destroyed() {
    },
    computed: {},
    methods: {
        apiFileDownload,
        hasSsamTalkData() {
            return !util.isEmpty(this.ssamTalkData);
        },
        isFinishSave() {
            if(!this.hasSsamTalkData()) {
                return false;
            }
            return this.ssamTalkData.ss_is_save == 1;
        },
        hasAudioFile() {
            if(!this.hasSsamTalkData()) {
                return false;
            }
            return !util.isEmpty(this.ssamTalkData.File) && !util.isEmpty(this.ssamTalkData.File[0].a_idx);
        },
        initData() {
            if(this.hasSsamTalkData()) {
                this.stepSeq = this.ssamTalkData.ss_seq;
                this.parentChange('stepSeq', this.stepSeq);
                if(!util.isEmpty(this.ssamTalkData.Editor)) {
                    this.talkKorean = this.ssamTalkData.Editor[0].sse_sentence_ko;
                    this.parentChange('talkKorean', this.talkKorean);
                    this.parentChange('beforeSetKorean', this.talkKorean);
                    this.talkEnglish = this.ssamTalkData.Editor[0].sse_sentence_en;
                    this.parentChange('talkEnglish', this.talkEnglish);
                }
            }
        },
        checkValidator(dataArr) {
            this.$validate(dataArr);
        },
        parentChange(key, value) {
            this.ssamTalkWriteSetData(key, value);
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
